/**
 * Created by JIA on 2021/5/25.
 * A helper class to detect if user is in China or not
 *  for now is used to auto choose speech recognize service
 */
import moment from "moment";
import ApiService from "../services/ApiService";
import _ from "lodash";

const detectIsChinaByDeviceLocale = () => {
    try {
        let language = navigator.language||navigator.userLanguage;

        return language.toLowerCase().indexOf("zh") > -1 || language.toLowerCase().indexOf("cn") > -1;
    } catch (e) {}

    return false;
};

const getJson = endpoint => {
    return new Promise((resolve, reject) => {
        fetch(endpoint)
            .then(response => response.json())
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const detectIsChinaByIPTypeBase = (endPoint, propName) => {
    return new Promise((resolve, reject) => {
        getJson(endPoint)
            .then(response => {
                //console.log(response);
                if (response.hasOwnProperty(propName)) {
                    const isChina = response[propName].toLowerCase() === "china";
                    resolve(isChina);
                }

                reject("");
            })
            .catch(error => {
                reject(error);
            });
    });
};
//{
//     "ip": "xx.xx.xx.xx",
//     "version": "IPv4",
//     "city": "Wuhan",
//     "region": "Hubei",
//     "region_code": "HB",
//     "country": "CN",
//     "country_name": "China",
//     "country_code": "CN",
//     "country_code_iso3": "CHN",
//     "country_capital": "Beijing",
//     "country_tld": ".cn",
//     "continent_code": "AS",
//     "in_eu": false,
//     "postal": null,
//     "latitude": 30.5851,
//     "longitude": 114.2662,
//     "timezone": "Asia/Shanghai",
//     "utc_offset": "+0800",
//     "country_calling_code": "+86",
//     "currency": "CNY",
//     "currency_name": "Yuan Renminbi",
//     "languages": "zh-CN,yue,wuu,dta,ug,za",
//     "country_area": 9596960.0,
//     "country_population": 1392730000.0,
//     "asn": "AS4134",
//     "org": "Chinanet"
// }
const endPoint1 = "https://ipapi.co/json/";
const detectIsChinaByIPType1 = () => {
    return detectIsChinaByIPTypeBase(endPoint1, "country_name");
};
//{
//    "businessName" : "",
//    "businessWebsite" : "",
//    "city" : "Hangzhou",
//    "continent" : "Asia",
//    "country" : "China",
//    "countryCode" : "CN",
//    "ipName" : "",
//    "ipType" : "Residential",
//    "isp" : "ChinaNet",
//    "lat" : "30.29365",
//    "lon" : "120.16142",
//    "org" : "ChinaNet",
//    "query" : "xx.xx.xx.xx",
//    "region" : "Zhejiang",
//    "status" : "success"
// }
const endPoint2 = "https://extreme-ip-lookup.com/json/";
const detectIsChinaByIPType2 = () => {
    return detectIsChinaByIPTypeBase(endPoint2, "country");
};
//{"country_name":"CHINA","country_code":"CN","city":"Wuhan","ip":"xx.xx.xx.xx"}
const endPoint3 = "https://api.hostip.info/get_json.php";
const detectIsChinaByIPType3 = () => {
    return detectIsChinaByIPTypeBase(endPoint3, "country_name");
};
//https://ipstack.com/documentation as backup

const detectIsChina = () => {
    return new Promise((resolve, reject) => {
        //first use ip type 1
        detectIsChinaByIPType3()
            .then(result => resolve(result))
            .catch(() =>
                //then type 2
                detectIsChinaByIPType2()
                    .then(result2 => resolve(result2))
                    .catch(() =>
                        //type 3
                        detectIsChinaByIPType1()
                            .then(result3 => resolve(result3))
                            .catch(() => {
                                //last use the device locale
                                resolve(detectIsChinaByDeviceLocale());
                            })
                    )
            );
    });
};

const expireTime = 300; //min

class LocationHelper {
    constructor() {
        this.isInChina = true;
        this.lastUpdateTime = moment().toISOString();
        //this.initIsInChina();
    }

    getIsInChina = () => {
        if (moment.duration(moment().diff(moment(this.lastUpdateTime))).asMinutes() > expireTime) {
            //re init after 300 min
            this.initIsInChina();
        }

        return this.isInChina;
    };

    initIsInChina = () => {
        ApiService.post(
            "/web/app/getCountryCode",
            {},
            response => {
                console.log(`LocationHelper: is in china ${response}`);
                let throwMe = true;
                if (_.isString(response) && !_.isEmpty(response)) {
                    throwMe = false;
                    this.isInChina = response.toLowerCase() === "cn";
                }

                if (throwMe) {
                    throw new Error("Wrong Response");
                }
            },
            response => {
                //console.log(`LocationHelper: is in china ${response}`);
                detectIsChina().then(isInChinaRes => {
                    this.lastUpdateTime = moment().toISOString();
                    console.log(`LocationHelper: is in china ${isInChinaRes}`);
                    this.isInChina = isInChinaRes;
                });
            }
        );
    };
}

export default new LocationHelper();

export { detectIsChina };
